/* Copyright 2012 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dijit/_WidgetBase",
    "dijit/_TemplatedMixin",
    "dijit/_Container",
    "dojo/text!./templates/MenubarWrapper.html",
    "./_WidgetMixin"
], function (declare, _WidgetBase, _TemplatedMixin, _Container, MenubarWrapperHtml, _WidgetMixin) {

    return declare([_WidgetBase, _TemplatedMixin, _Container, _WidgetMixin], {
        /** @lends MenubarWrapper# */

        /**
         * @class This is a container control to be used for hosting a Menubar in the Toolstrip.
         * @extends dijit/_Container
         */
        templateString: MenubarWrapperHtml
    });

});